<template>
  <div class="dd-first-screen" ref="root">
    <video 
      muted
      autoplay
      playsinline
      webkit-playsinline
      loop
      ref="video"
      class="dd-first-screen__video"
      src="background.mp4">
    </video>
    <div class="dd-first-screen__overlay">
      <h1 class="dd-first-screen__slogan">让数据可视化</h1>
      <p class="dd-first-screen__text">金十数据旗下行情分析软件</p>
      <router-link to="/about" class="dd-first-screen__btn">了解更多</router-link>
    </div>
    <Icon type="arrow-down" class="dd-first-screen__tip"/>
  </div>
</template>

<script>
export default {
  mounted () {
    this.setVideoSizeCover()
    window.addEventListener('resize', this.setVideoSizeCover)
  },
  destroyed () {
    window.removeEventListener('resize', this.setVideoSizeCover)
  },
  methods: {
    setVideoSizeCover () {
      const { root, video } = this.$refs
      const zoomRatio = Math.max(
        root.clientWidth / video.videoWidth,
        root.clientHeight / video.videoHeight
      )
      video.style.width = video.videoWidth * zoomRatio + 'px'
      video.style.height = video.videoHeight * zoomRatio + 'px'
    }
  }
}
</script>

<style lang="scss">
.dd-first-screen {
  position: relative;
  height: 100%;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0, .6);
  }
  &__video {
    position: absolute;
    z-index: -1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
  }
  &__overlay {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
  }
  &__slogan {
    line-height: 48px;
    font-size: 36px;
    letter-spacing: 1px;
  }
  &__text {
    margin: 27px 0 50px;
    font-size: 21px;
    line-height: 1;
    letter-spacing: 8px;
    white-space: nowrap;

    &:before,
    &:after {
      content: "-";
    }
  }
  &__btn {
    display: inline-block;
    width: 150px;
    height: 54px;
    line-height: 54px;
    background: linear-gradient(90deg,rgba(88,75,213,1) 0%,rgba(83,160,253,1) 48%,rgba(81,125,236,1) 100%);
    border-radius: 4px;
    font-weight: bold;
    color: inherit;
    cursor: pointer;
  }
  &__tip {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 50px;
    animation: afloat .8s ease-in-out infinite alternate;
  }
  @include media-tablet {
    background: url("../assets/first_screen.jpg") no-repeat center;
    background-size: cover;

    &__video {
      display: none;
    }
    &__slogan {
      font-size: 22px;
    }
    &__text {
      margin: 16px 0 30px;
      font-size: 13px;
      letter-spacing: 5px;
    }
    &__btn {
      width: 91px;
      height: 33px;
      line-height: 33px;
      font-size: 10px;
    }
    &__tip {
      font-size: 40px;
    }
  }
}

@keyframes afloat {
  from {
    transform: translate(-50%, -10%);
  }
  to {
    transform: translate(-50%, 25%);
    opacity: .5;
  }
}
</style>
